import script from "./DoctorInfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorInfoCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__